/**
 * Provenance line for a NETRA score shown on a CHANNEL order.
 *
 * A channel-order score is deliberately frozen at ingest — it is never
 * re-derived from the ProShip order(s) the channel order later becomes. That
 * keeps the listing cheap and predictable (no cross-collection lookup, no
 * "which of the N shipments?" rule), but it means the same buyer and address
 * can legitimately show a different score here than on the Orders page.
 *
 * Without an explicit label that divergence reads as a bug, so every
 * channel-order card states the stage and the date it was scored.
 *
 * "Ingest" means the LATEST channel-stage score: if WhatsApp address
 * verification rewrites the address, NETRA re-scores and replaces this. What is
 * frozen is the stage, not the timestamp.
 */
export function netraStageNote(netra) {
  if (!netra) return undefined
  const raw = netra.scoredAt
  if (!raw) return 'Scored at order ingest'
  const d = new Date(raw)
  if (Number.isNaN(d.getTime())) return 'Scored at order ingest'
  const when = d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
  return `Scored at order ingest · ${when}`
}

export default netraStageNote
